
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import { Bootstrapper } from "Bootstrapper"
import { UseBusyIndicatorStore, Update as BusyUpdate } from 'stores/BusyIndicatorStore';
import LoadingButton from "components/buttons/LoadingButton"


const PasswordResetLink = (props: any) => {
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];

    const userService = new UserService();
    const isAuthenticated = userService.isAuthenticated();
    const [linkRequested, setLinkRequested] = useState<boolean>();
    const [canSubmit, setCanSubmit] = useState<boolean>(true);
    const [email, setEmail] = useState<string>();
    const [validationMsg, setValidationMsg] = useState<string>("");
    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);

    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }


    useEffect(() => {
        loadDataAsync();
    }, []);


    const loadDataAsync = async() => {
        BusyUpdate(true);
        const activeUser = isAuthenticated ? await userService.getUserAsync(userService.getActiveUserId()) : null;
        const email = activeUser?.userName
        setEmail(email);            
        BusyUpdate(false);        

    }


    const onRequestResetLinkAsync = async() => {
        if(!canSubmit)
            return;
        setValidationMsg("");
        if(email == null || ""){
            setValidationMsg("Email is required");
            return;
        }

        setCanSubmit(false);
        var result = await userService.sendPasswordResetLinkAsync(email).catch((err: Error) => {
            setValidationMsg(err.message);
        });
        
        setLinkRequested(result === true);

        setCanSubmit(true);
    }

    const action = linkRequested ? null : <LoadingButton loading={!canSubmit} disabled={!canSubmit} onClick={() => onRequestResetLinkAsync()} fullWidth>Submit</LoadingButton>;
    return(
        <Section sx={{flexGrow: 1}} id="section-plans" bgColor={bg2}>
            <Container maxWidth="xs">
                <Animation overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='fade' direction='left' transitionDelay={0}>
                    <div>
                    <Form 
                    validationMsg={validationMsg}
                    action={action}
                    title={linkRequested ? "Link Requested!" : "Request Reset Link"}>
                        {linkRequested && <Text>Check your email for a link to reset your password</Text>}
                        {!linkRequested && <FieldCollection>
                            <TextField disabled={isAuthenticated} isReadOnly={isAuthenticated} value={email || ""} onChange={(ele: any) => setEmail(ele.target.value)} label="Email" />
                        </FieldCollection>}
                    </Form>
                    </div>

                </Animation>
            </Container>
        </Section>
    )

}

export default PasswordResetLink
